import { useMemo } from 'react';

import { ReadonlyDetail } from '@/common/components/employees/shared/ReadonlyDetail';
import { EMPTY_DEFAULT } from '@/common/components/shared/table/constants';
import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { DateUtils } from '@/common/utils';

export const PassportDetails = () => {
  const { employeeDetail } = useEmployeeDetailContext();

  const { text: passportIssuedDateText, isFuture: passportIssuedDateIsFuture } = useMemo(
    () => DateUtils.getDifferenceString(employeeDetail.personalInformation.passportIssuedDate),
    [employeeDetail.personalInformation.passportIssuedDate],
  );
  const { text: passportExpiryDateText, isFuture: passportExpiryDateIsFuture } = useMemo(
    () => DateUtils.getDifferenceString(employeeDetail.personalInformation.passportExpiryDate),
    [employeeDetail.personalInformation.passportExpiryDate],
  );

  return (
    <div className="mb-6">
      <div className="mb-4 font-semibold">Passport</div>
      <fieldset className="form-fieldset">
        <ReadonlyDetail label="Passport Number">{employeeDetail.personalInformation.passportNumber}</ReadonlyDetail>

        <ReadonlyDetail label="Full Name on Passport">{employeeDetail.personalInformation.passportName}</ReadonlyDetail>

        <ReadonlyDetail label="Passport Issued Place">
          {employeeDetail.personalInformation.passportIssuedPlace}
        </ReadonlyDetail>

        <ReadonlyDetail label="Passport Issued Date">
          {DateUtils.formatDate(employeeDetail.personalInformation.passportIssuedDate) || EMPTY_DEFAULT}
          <div className="text-gray-7 text-xs">
            {passportIssuedDateText}
            {!passportIssuedDateIsFuture ? ' ago' : ''}
          </div>
        </ReadonlyDetail>

        <ReadonlyDetail label="Passport Expiry Date">
          {DateUtils.formatDate(employeeDetail.personalInformation.passportExpiryDate) || EMPTY_DEFAULT}
          <div className="text-gray-7 text-xs">
            {passportExpiryDateText}
            {!passportExpiryDateIsFuture ? ' ago' : ''}
          </div>
        </ReadonlyDetail>

        <ReadonlyDetail label="Place of Birth">{employeeDetail.personalInformation.placeOfBirth}</ReadonlyDetail>
      </fieldset>
    </div>
  );
};
